import {
  useAddTaskPlannedResourceMutation,
  useAssignRouteToTaskMutation,
  useCreateOrUpdateTaskNotesMutation,
  useCreateTaskMutation,
} from 'app/api';
import { handleError } from 'app/containers/Global/slice/helpers';
import { ICreateTaskPayload } from 'app/containers/Task/slice/types';
import { RouteConstants } from 'app/routes';
import { generatePath, useHistory } from 'react-router-dom';
import { showCreateTaskSuccessNotification } from 'utils/notifications';

export const useCreateTask = () => {
  const history = useHistory();

  const [createTask] = useCreateTaskMutation();
  const [createOrUpdateTaskNotes] = useCreateOrUpdateTaskNotesMutation();
  const [addTaskPlannedResource] = useAddTaskPlannedResourceMutation();
  const [assignRouteToTask] = useAssignRouteToTaskMutation();

  const onTaskCreate = async ({
    payload,
    routeIds,
  }: {
    payload: ICreateTaskPayload;
    routeIds: number[];
  }) => {
    try {
      const {
        task: taskData,
        envId,
        onSuccessRedirectTo,
        plannedResources,
      } = payload;

      const task = await createTask({ envId, taskData }).unwrap();

      if (taskData.note) {
        await createOrUpdateTaskNotes({
          envId,
          taskId: task.id,
          notes: taskData.note,
        }).unwrap();
      }

      await Promise.all(
        plannedResources.map(plannedResource =>
          addTaskPlannedResource({
            envId,
            taskId: task.id,
            norm: plannedResource.norm,
            resourceId: plannedResource.resourceId,
          }).unwrap(),
        ),
      );

      if (routeIds.length) {
        await Promise.all(
          routeIds.map(routeId =>
            assignRouteToTask({
              envId,
              routeId,
              taskId: task.id,
            }).unwrap(),
          ),
        );
      }

      history.push(
        onSuccessRedirectTo ||
          generatePath(RouteConstants.task.details, {
            envId: Number(envId),
            taskId: Number(task.id),
          }),
      );

      showCreateTaskSuccessNotification();
    } catch (error) {
      handleError(error);
    }
  };
  return { onTaskCreate };
};
